import { ContentType, apiRequest } from '../../main/services/api'
import mapActionCreators from '../maps/store/action-creators'
import { PerfData } from '../maps/types'
import { intervalCallbackOnWindowVisible } from '../shared/documentVisibility'
import { parseJSONFromScript } from '../shared/parseJSONFromScript'
import { Indices, updateIndices } from './indices-data'

interface RefreshInfo {
  userId: string
  version: number
  interval: number
}

const refreshInfo = parseJSONFromScript<RefreshInfo>('refresh-init')

function refreshPage(result: string) {
  const newDocument = new DOMParser().parseFromString(result, 'text/html')
  const newRefreshInfo = parseJSONFromScript<RefreshInfo>('refresh-init', newDocument)

  if (!refreshInfo || !newRefreshInfo || refreshInfo.userId !== newRefreshInfo.userId) return

  if (refreshInfo.version !== newRefreshInfo.version) {
    window.location.reload()
  }

  // Replace left signals table
  const oldSignalsLeft = document.getElementById('js-signals_1')
  const newSignalsLeft = newDocument.getElementById('js-signals_1')
  if (oldSignalsLeft && newSignalsLeft) {
    oldSignalsLeft.innerHTML = newSignalsLeft.innerHTML
  }

  // Replace right signals table
  const oldSignalsRight = document.getElementById('js-signals_2')
  const newSignalsRight = newDocument.getElementById('js-signals_2')
  if (oldSignalsRight && newSignalsRight) {
    oldSignalsRight.innerHTML = newSignalsRight.innerHTML
  }

  // Replace right signals table
  const oldHomepageBottom = document.getElementById('js-homepage_bottom')
  const newHomepageBottom = newDocument.getElementById('js-homepage_bottom')
  if (oldHomepageBottom && newHomepageBottom) {
    oldHomepageBottom.innerHTML = newHomepageBottom.innerHTML
  }

  // Update indices
  try {
    const newIndicesData = parseJSONFromScript<Indices>('js-indices', newDocument)
    if (newIndicesData) {
      updateIndices(newIndicesData)
    }
  } catch (error) {
    Sentry.withScope((scope: any) => {
      scope.setContext('Body', { size: result.length })
      Sentry.captureException(error)
    })
  }

  try {
    // Render maps
    const mapData = parseJSONFromScript<{ perfDataSec: PerfData; perfDataGeo: PerfData }>('map-data', newDocument)
    mapActionCreators.updatePerfData(window.FinvizIndexSecMap, mapData?.perfDataSec)
    mapActionCreators.updatePerfData(window.FinvizIndexGeoMap, mapData?.perfDataGeo)
  } catch {}

  /**
   * Re-render recent quotes. The script (recent_quotes.js) is only included for premium users
   * so we need to check if it's defined
   */
  if (typeof window['RenderRecentQuotes'] === 'function') {
    RenderRecentQuotes()
  }

  // Send refresh event to google analytics
  window.gtag?.('event', 'refresh', { event_category: 'page' })
  // Refresh any ads that might be on the page
  if (window.finvizBannersLoaded === true) {
    window.initFinvizBanners?.()
  } else if (typeof window.refreshAds === 'function') {
    window.refreshAds('#js-homepage_bottom [id*=IC_D_]')
  }
}

function initRefresh(interval: number) {
  intervalCallbackOnWindowVisible(interval, async function handleRefresh() {
    const data = await apiRequest<string>(window.location.pathname, {
      headers: { 'Content-Type': ContentType.Html },
    })

    if (data) {
      refreshPage(data)
    }
  })
}

if (refreshInfo?.interval) {
  initRefresh(refreshInfo.interval * 1000)
}
